import { FC } from 'react'

import { CTAButton } from 'src/Components/Buttons/CTAButton'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'

import { ButtonWrapper } from '../styles'
import { PlanStatusEnum } from '../../../helpers'

interface Props {
  onClick: () => void
  status: PlanStatusEnum
}

export const PlanButton: FC<Props> = ({ onClick, status }) => {
  if (status === PlanStatusEnum.UPGRADE) {
    return (
      <ButtonWrapper>
        <CTAButton onClick={onClick}>Upgrade</CTAButton>
      </ButtonWrapper>
    )
  }
  if (status === PlanStatusEnum.DEACTIVATED) {
    return (
      <ButtonWrapper>
        <PrimaryDottedButton onClick={onClick}>
          Activate subscription
        </PrimaryDottedButton>
      </ButtonWrapper>
    )
  }
  if (status === PlanStatusEnum.DOWNGRADE) {
    return (
      <ButtonWrapper>
        <PrimaryDottedButton onClick={onClick}>Downgrade</PrimaryDottedButton>
      </ButtonWrapper>
    )
  }
  if (status === PlanStatusEnum.ACTIVE) {
    return (
      <ButtonWrapper>
        <PrimaryDottedButton onClick={onClick}>
          Cancel subscription
        </PrimaryDottedButton>
      </ButtonWrapper>
    )
  }
  return (
    <ButtonWrapper>
      <CTAButton onClick={onClick}>Subscribe</CTAButton>
    </ButtonWrapper>
  )
}
